<template>

    <div class="c-form_radio_group">
        <form-label>{{ label }}</form-label>
        <div class="c-form_radio_group__container">
            <slot></slot>
        </div>
    </div>

</template>


<script>

import FormLabel from './FormLabel'

export default {

    name: 'FormRadioGroup',

    props: {
        label: String
    },

    components: {
        FormLabel
    }

}

</script>


<style lang="scss">

.c-form_radio_group {
    width: 100%;
    margin-bottom: 1rem;

    &__container {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
    }
}

</style>
